export default "__VITE_ASSET__DBqF9C9J__"